import { render } from "./Hospitals.vue?vue&type=template&id=5c4215e4&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"

import "./Hospitals.vue?vue&type=style&index=0&id=5c4215e4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5c4215e4"

export default script